// extracted by mini-css-extract-plugin
export var actions = "_4i-0";
export var actionsContainer = "_4i-6";
export var border = "_4i-1";
export var childFullHeight = "_4i-d";
export var collapse = "_4i-2";
export var content = "_4i-8";
export var contentChild = "_4i-c";
export var fullscreen = "_4i-a";
export var hasLeftRadius = "_4i-i";
export var headerContainer = "_4i-3";
export var headerRow = "_4i-5";
export var hidePadding = "_4i-9";
export var navCollapsedGap = "_4i-j";
export var noScrollX = "_4i-k";
export var noScrollY = "_4i-l";
export var noTopPadding = "_4i-g";
export var optOutTopPadding = "_4i-b";
export var pageMain = "_4i-h";
export var pageOuter = "_4i-e";
export var pagePadding = "_4i-7";
export var profile = "_4i-m";
export var profileContainer = "_4i-n";
export var profileImage = "_4i-o";
export var profileMain = "_4i-p";
export var profileSubtitle = "_4i-r";
export var profileTitle = "_4i-q";
export var showLeftPadding = "_4i-f";
export var tabsWrapper = "_4i-4";
export var title = "_4i-s";